/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { YardLocalDetail } from '../../shared/model/yard-local-detail.model';
import { StationDetail } from './../../shared/model/station-detail.model';


/**
 * @export
 * @class YardLocalContainerComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-yard-local-container',
  templateUrl: './yard-local-container.component.html',
  styleUrls: ['./yard-local-container.component.scss']
})

export class YardLocalContainerComponent {

  @Input() locateLocoId: string;
  @Input() yardLocalDetail: YardLocalDetail;
  @Input() stationDetailArr: Array<StationDetail>;
  @Output() locoStationSelectionEvent = new EventEmitter<Array<StationDetail>>();
  @Output() onLocoSelect = new EventEmitter();
  @Output() showStationMenu = new EventEmitter();

  /**
   * @param {any} event
   *
   * @memberof YardLocalContainerComponent
   */
  locoOrStationSelectionEvent(event) {
    this.locoStationSelectionEvent.emit(event);
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalContainerComponent
   */
  showLocoContextMenu(event) {
    this.onLocoSelect.emit(event);
  }

  /**
   * @param {any} event
   *
   * @memberof YardLocalContainerComponent
   */
  showStationContextMenu(event) {
    this.showStationMenu.emit(event);
  }

  /**
   * Invoked when grid level filter change.
   * @param {any} event
   * @memberof YardLocalContainerComponent
   */
  filterDataEvent(event) {
    if (event) {
      this.stationDetailArr = event;
    }
  }

}
